import * as types from './_actionTypes';


const initialState = {
loading: false,
data: [],
error: null,
};


export default function studentNotificationsReducer(state = initialState, action) {
switch (action.type) {
case types.FETCH_STUDENT_NOTIFICATIONS_REQUEST:
return { ...state, loading: true, error: null };


case types.FETCH_STUDENT_NOTIFICATIONS_SUCCESS:
return { ...state, loading: false, data: action.payload || [], error: null };


case types.FETCH_STUDENT_NOTIFICATIONS_FAILURE:
return { ...state, loading: false, error: action.payload };


default:
return state;
}
}